import styled from 'styled-components'
import vector from '../../../../assets/equipment/vector.svg'
import vectorlight from '../../../../assets/equipment/vectorlight.svg'

export const SubHeaderContainer = styled.div`
  background-color: #fff;
  margin-bottom: 0;
  padding: 1.3rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
`

export const MainContainer = styled.div`
  background-color: #f4f4f4;
  overflow-y: auto;
  padding: 0rem 0rem;
  min-height: calc(100vh - 140px);
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const SectionName = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  width: fit-content;
  margin: 0;
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`

export const BreadcrumbsContainer = styled.nav`
  font-size: 14px;
  padding: 1rem 0rem;
  
  ol {
    list-style: none;
    padding: 0;
    padding-inline-start: 0;
    margin: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  
  li {
    display: flex;
    align-items: center;
    color: var(--light-text-color, #666);
    
    &:not(:last-child)::after {
      content: '>';
      margin: 0 8px;
      color: var(--input-border, #999);
    }
    
    a {
      text-decoration: none;
      color: #0090d3;
      white-space: nowrap;
      cursor: pointer;

    
    &:last-child {
      span {
        color: var(--text-color, #333);
        white-space: nowrap;
        cursor: default;
      }
      
      a {
        color: var(--text-color, #333);
        cursor: default;
        text-decoration: none;
      }
    }
  }
`

export const StyledCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 25px 20px;
  margin-bottom: 20px;
`

export const StyledCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

export const CardTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  padding-bottom: 20px;
`

export const FormGrid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols}, 1fr);
  gap: 20px 30px;
  
  @media (max-width: 992px) {
    grid-template-columns: ${(props) =>
      props.cols === 3 ? 'repeat(2, 1fr)' : 'repeat(2, 1fr)'};
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  label {
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: bold;
  }

  input,
  select {
    padding: 8px 15px;
    border: 1px solid var(--input-border, #ddd);
    border-radius: 100px;
    font-size: 14px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    line-height: 22px;
    background-color: #ebebeb;
    color: #333;

    &::placeholder {
      color: #999;
    }

    &:focus {
      border-color: #0090d3;
    }

    &:disabled,
    &[readonly] {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
      border-color: #dfdfdf;
    }
  }

  select {
    background-image: url(${vector});
    background-size: 18px 9px;
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 2.5rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;

    option[value=''] {
      color: #999;
    }
    
    option {
      color: #333;
      background-color: white;
    }

    &:disabled,
    &[readonly] {
      background-image: url(${vectorlight});
      background-size: 32px 16px;
      cursor: not-allowed;
    }
  }
`

export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
`

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 40px 10px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  background-color: #f5f5f5;
  color: #333;

  &::placeholder {
    color: #999;
  }

  &:focus {
    border-color: #0090d3;
    background-color: #fff;
  }
`

export const SearchIcon = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`

export const StageTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 16px;
  min-height: 32px;
`

export const StageTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: #e3f2fd;
  border-radius: 16px;
  font-size: 14px;
  color: #0090d3;
  font-weight: 500;

  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    font-size: 18px;
    line-height: 1;
    color: #0090d3;
    font-weight: 600;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    
`

export const AddButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  img {
    width: 12px;
    height: 12px;
  }
`

export const SectionItem = styled.div`
  position: relative;
  background-color: #fafafa;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  border: 2px solid #d0d0d0;

  &:last-child {
    margin-bottom: 0;
  }
`

export const DeleteButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #d32f2f;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
`

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;

`

export const SaveButton = styled.button`
  background-color: #0090d3;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    width: 16px;
    height: 16px;
  }
`

export const StageItemContainer = styled(SectionItem)`
  padding-right: 60px;
`

export const MaterialItemContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: start;
  padding: 16px 0;
  border-radius: 12px;
  border: 1px solid #d0d0d0;
  padding: 16px;
  margin-bottom: 12px;
`

export const MaterialFields = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const InlineDeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #00bcd4;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-top: 20px;
  min-width: 40px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

export const SupplyItemContainer = styled(SectionItem)`
  padding-right: 60px;
`

export const ServiceItemContainer = styled(SectionItem)`
  padding-right: 60px;
`

export const DisabledFieldContainer = styled.div`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(196, 196, 196, 0.3);
    border-radius: 100px;
    pointer-events: none;
  }
`

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const DropdownItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`

export const DropdownOrderHeader = styled.div`
  padding: 8px 12px;
  font-weight: bold;
  background-color: #f9f9f9;
  border-bottom: 1px solid #e0e0e0;
`

export const DropdownItemInfo = styled.div`
  font-size: 12px;
  margin-top: 2px;
`

export const SectionButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding-top: 16px;
`